import React from 'react';
import {Box, Button, Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import {formatData} from './dateExpozitie';

// 44.4: `cuDetaliu` — artistul a ales un fragment clar (afisat ca imagine principala): titlul o spune;
// fara fragment ramane „Inainte de dezvaluire” si textul nu pretinde un detaliu clar.
export default function NotaPrevizualizare({expozitie, profil, contextArtist = false, cuDetaliu = false}) {
    return <Box component="section" aria-label="Despre previzualizare" sx={{my: 2, p: {xs: 2, sm: 3}, border: '1px solid var(--gallery-border)', borderRadius: 1}}>
        <Typography component="h2" variant="h6" sx={{mb: 1}}>{cuDetaliu ? 'Un detaliu, înainte de dezvăluire' : 'Înainte de dezvăluire'}</Typography>
        <Typography sx={{mb: expozitie || profil ? 2 : 0}}>
            {expozitie ? <>
                {contextArtist ? 'Descoperă universul artistului în expoziția' : 'Descoperă lucrarea integrală în expoziția'}{' '}
                „{expozitie.numeExpozitie}”{expozitie.deschidere && <>, din {formatData(expozitie.deschidere)}</>}.
            </> : contextArtist
                ? 'Unele lucrări sunt prezentate momentan în previzualizare. Imaginile lor integrale se dezvăluie odată cu expunerea într-o expoziție.'
                : cuDetaliu
                    ? 'Lucrarea este prezentată momentan printr-un detaliu ales de artist. Imaginea integrală se dezvăluie odată cu expunerea într-o expoziție.'
                    : 'Lucrarea este prezentată momentan în previzualizare. Imaginea integrală se dezvăluie odată cu expunerea într-o expoziție.'}
        </Typography>
        {expozitie ? <Button component={Link} to={`/expozitii/${encodeURIComponent(expozitie.slug)}`} variant="outlined">Vezi expoziția</Button>
            : profil && <Button component={Link} to={profil} variant="outlined">Descoperă portofoliul</Button>}
    </Box>;
}
